module.exports = __webpack_public_path__ + "img/home-1050x630.6cbe8dd5.jpg";